/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ListItemButton, ListItemIcon } from '@mui/material';

import SubMenuDialog from './subMenuDialog';

import { TextStyle, styles } from './LeftNavBar.styles';
import { Icons } from '../../../Constants/Icons';

interface ILogoutDialogProps {
  isSideBarVisible: boolean;
  theme: any;
  isTablet: boolean;
}

const SubMenu: React.FC<ILogoutDialogProps> = ({ isSideBarVisible, theme, isTablet }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(['logout']);

  const handleClickOpen = (): void => {
    setOpen(true);
  };

  return (
    <>
      <ListItemButton
        onClick={handleClickOpen}
        sx={{
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightBold,
          },
          padding: isTablet ? '0.5rem 0.75rem' : '1rem',
          borderRadius: isTablet ? '0.5rem' : '1rem',
          marginBottom: '0.5rem',
          alignItems: isSideBarVisible ? 'flexStart' : 'center',
          justifyContent: isSideBarVisible ? 'flexStart' : 'center',
          width: '100%',
        }}>
        <ListItemIcon
          sx={{
            ...styles.iconStyle,
          }}>
          <img src={Icons.AllJobsIcon} alt={t('homePage:jobManagementDashboard')} />
        </ListItemIcon>
        {isSideBarVisible && <TextStyle>{t('homePage:jobManagementDashboard')}</TextStyle>}{' '}
      </ListItemButton>

      <SubMenuDialog
        isApproveWindowOpen={open}
        handleCloseApproveWindow={() => setOpen(false)}
        isSideBarVisible={isSideBarVisible}
        isTablet={isTablet}
      />
    </>
  );
};

export default SubMenu;
